import { render, staticRenderFns } from "./ztsz-xwdt.vue?vue&type=template&id=983d7136&"
import script from "./ztsz-xwdt.vue?vue&type=script&lang=js&"
export * from "./ztsz-xwdt.vue?vue&type=script&lang=js&"
import style0 from "./ztsz-xwdt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports